import { BehaviorSubject } from 'rxjs'

export default class Model {
	private documentCache = new Map<
		string,
		BehaviorSubject<null | firebase.firestore.DocumentSnapshot>
	>()
	private collectionCache = new Map<
		string,
		BehaviorSubject<null | firebase.firestore.QuerySnapshot>
	>()

	constructor(private db: firebase.firestore.Firestore) {}

	public getDocByPath(
		path: string
	): BehaviorSubject<null | firebase.firestore.DocumentSnapshot> {
		if (this.documentCache.has(path)) {
			return this.documentCache.get(path)
		}
		const subject = new BehaviorSubject(null)
		this.documentCache.set(path, subject)
		this.db.doc(path).onSnapshot(doc => {
			subject.next(doc)
		})
		return subject
	}

	public getCollectionByPath(
		path
	): BehaviorSubject<null | firebase.firestore.QuerySnapshot> {
		if (this.collectionCache.has(path)) {
			return this.collectionCache.get(path)
		}
		const subject = new BehaviorSubject(null)
		this.collectionCache.set(path, subject)
		this.db.collection(path).onSnapshot(doc => {
			subject.next(doc)
		})
		return subject
	}
}



// WEBPACK FOOTER //
// ./src/Model.ts